<template>
  <!-- 报警信息 -->
  <div class="infoCode">
    <!-- 状态码 -->
    <div class="head">
      <div class="code">
        <div>状态码:</div>
        <div>{{data.value}}</div>
      </div>
      <div class="time">
        <div>{{data.time}}</div>
        <!-- <div></div> -->
      </div>
    </div>
    <!-- 状态内容 -->
    <div class="content">
      <div class="status">状态消息</div>
      <div class="status-info">
        {{data.message}}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props:["chartData"],
  data() {
    return {
      data:{},
      getDataInterval: null,
    };
  },
  mounted() {
    this.data = this.chartData;
    this.getDataInterval = setInterval(() => {
      this.data =  this.chartData;
    },2000)
  },
  methods: {},
  destroyed(){
    //清除定时器
    if (this.getDataInterval)clearInterval(this.getDataInterval);
  }
};
</script>
<style lang="less" scoped>
.infoCode {
  width: 100%;
  height: 90px;
  margin-top: 14px;
  background: url("./images/infoCode-bg.png") no-repeat 0 0;
  background-size: 100% 100%;

  .head {
    height: 28px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 12px;

    .code {
      display: flex;

      div {
        font-size: 14px;
        font-weight: 500;
        color: #ffffff;
      }
    }

    .time {
      display: flex;

      div {
        font-size: 14px;
        font-weight: 500;
        color: #ffffff;
        margin-left: 12px;
      }
    }
  }

  .content {
    width: 100%;
    height: calc(100% - 28px);
    padding: 4px 12px;
    overflow-y: auto;

    .status {
      font-size: 14px;
      font-weight: 400;
      color: #37ffe9;
    }

    .status-info {
      font-size: 12px;
      font-weight: 400;
      color: #ffffff;
    }
  }
}
</style>